import { Controller } from "@hotwired/stimulus"

// Submits the controller's own form as soon as a tracked input changes —
// used by the event-banner image inputs, where picking a file commits the
// upload immediately (separate from the "Mostrar no site" toggle, which
// keeps its own explicit Salvar button).
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
